export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="rounded-2xl bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-extrabold text-background-50 mb-3">
                移动观影更便捷
              </h2>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed font-body mb-6">
                豆花视频全面适配手机和平板，随时随地免费在线观看。无需下载App，浏览器打开即享高清流畅体验，追剧看片不受限。
              </p>
              <div className="flex flex-wrap items-center gap-3 justify-center lg:justify-start">
                <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-primary-700 text-sm font-semibold font-label rounded-lg whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors">
                  <i className="ri-smartphone-line"></i>
                  手机端访问
                </span>
                <span className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50/20 text-background-50 text-sm font-semibold font-label rounded-lg border border-background-50/30 whitespace-nowrap cursor-pointer hover:bg-background-50/30 transition-colors">
                  <i className="ri-tablet-line"></i>
                  平板端访问
                </span>
              </div>
            </div>
            <div className="shrink-0">
              <div className="w-40 h-72 md:w-48 md:h-80 rounded-2xl overflow-hidden border-4 border-background-50/30 bg-background-50/10 p-2">
                <div className="w-full h-full rounded-xl bg-background-50/20 flex flex-col items-center justify-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500">
                    <i className="ri-movie-2-line text-background-50 text-lg"></i>
                  </div>
                  <span className="text-xs font-heading font-bold text-background-50">豆花视频</span>
                  <span className="text-[10px] text-background-50/60 font-body">高清流畅观影</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}